import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D1E543C5-6ECA-43AA-B04D-438319BC5562
 * name swap-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-horizontal.svg
 * tags
 * - Arrow 
 */
export const SwapHorizontalIcon = createSvgIcon(<><path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" /></>, 'SwapHorizontalIcon');
export default SwapHorizontalIcon